import clsx from "clsx";
import React from "react";
import styles from "./Spinner.module.scss";

export type SpinnerProps = {
  color: "neutral10" | "white" | "titanium";
  size: "small" | "medium" | "large";
};

export const Spinner: React.FC<React.PropsWithChildren<SpinnerProps>> = ({
  color,
  size
}) => {
  return (
    <div
      className={clsx(styles.spinner, {
        [styles.sizeSmall]: size == "small",
        [styles.sizeMedium]: size == "medium",
        [styles.sizeLarge]: size == "large",
        [styles.colorNeutral]: color == "neutral10",
        [styles.colorWhite]: color == "white",
        [styles.colorTitanium]: color == "titanium"
      })}
    ></div>
  );
};
